import { type SheetTypes } from '@svenskaspelab/poolbetting/schema/input';

export const OPEN_SHEET_EVENT = 'powerplay:open-sheet';
export const CLOSE_SHEET_EVENT = 'powerplay:close-sheet';

export type OpenSheetEventDetail = {
  sheet: SheetTypes;
};

/**
 * Dispatches a custom event to open the specified sheet.
 *
 * @param sheet The sheet type to open
 */
export function dispatchOpenSheet(sheet: SheetTypes): void {
  window.dispatchEvent(new CustomEvent<OpenSheetEventDetail>(OPEN_SHEET_EVENT, { detail: { sheet } }));
}

/**
 * Dispatches a custom event to close the currently open sheet.
 */
export function dispatchCloseSheet(): void {
  window.dispatchEvent(new CustomEvent(CLOSE_SHEET_EVENT));
}
